import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { WhyItFailed } from '../components/WhyItFailed';
import { Mechanism } from '../components/Mechanism';
import { Features } from '../components/Features';
import { TargetAudience } from '../components/TargetAudience';
import { HowItWorks } from '../components/HowItWorks';
import { Snapshot } from '../components/Snapshot';
import { FAQ } from '../components/FAQ';
import { Pricing } from '../components/Pricing';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-cream font-sans" data-id="element-202">
      <Hero data-id="element-203" />
      <Problem data-id="element-204" />
      <WhyItFailed data-id="element-205" />
      <Mechanism data-id="element-206" />
      <Features data-id="element-207" />
      <TargetAudience data-id="element-208" />
      <HowItWorks data-id="element-209" />
      <Snapshot data-id="element-210" />
      <FAQ data-id="element-211" />
      <Pricing data-id="element-212" />
      <Footer data-id="element-213" />
    </main>;
}